
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';

moment.locale('it');

@Component
export default class DatePicker extends Vue {
  @Prop({ type: String, default: null }) readonly value!: string | null;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: true }) readonly editable!: boolean;

  newValue: string | null = null
  newTextValue: string | null = null

  @Watch('value')
  onValue(val: string | null) {
    console.log(`${this.constructor.name}: onValue() val =`, val); // eslint-disable-line no-console

    this.newValue = val;
    this.newTextValue = val
      ? moment(val, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : null;
  }

  // Rileva la modifica del valore del campo di testo
  @Watch('newTextValue')
  onNewTextValue(val: string | null) {
    console.log(`${this.constructor.name}: onNewTextValue() val =`, val); // eslint-disable-line no-console

    // Trasforma in un valore di tipo Date prima di restituirlo
    const newValue = val
      ? moment(val, 'DD/MM/YYYY', true).toDate()
      : null;
    console.log(`${this.constructor.name}: onNewTextValue() newValue =`, newValue); // eslint-disable-line no-console

    // Se è una data valida, la memorizza in this.newValue nel formato corretto
    if (newValue && moment(newValue).isValid()) {
      this.newValue = moment(newValue).format('YYYY-MM-DD');
    } else if (newValue === null) {
      // Se è null, la memorizza in this.newValue (data cancellata)
      this.newValue = null;
    }
  }

  // Rileva la modifica del valore del datepicker
  @Watch('newValue')
  onNewValue(val: string | null) {
    console.log(`${this.constructor.name}: onNewValue() val =`, val); // eslint-disable-line no-console

    // Trasforma in un valore di tipo Date prima di restituirlo
    const newValue = val
      ? moment(val, 'YYYY-MM-DD').toDate()
      : null;

    // Se è una data valida, la memorizza in this.newTextValue nel formato corretto
    if (newValue && moment(newValue).isValid()) {
      const newTextValue = moment(newValue).format('DD/MM/YYYY');
      if (this.newTextValue !== newTextValue) {
        this.newTextValue = newTextValue;
      }
    } else if (newValue === null) {
      // Se è null, la memorizza in this.newTextValue (data cancellata)
      if (this.newTextValue !== null) {
        this.newTextValue = null;
      }
    }
  }

  // Controlla se la data è valida
  isValid(val: string | null) {
    // Se è null, la data è valida
    if (val === null) {
      return true;
    }

    // Controlla se la data è valida
    const date = moment(val, 'DD/MM/YYYY', true).toDate();
    return moment(date).isValid();
  }

  // È stato aperto il dialog
  onOpen() {
    console.log(`${this.constructor.name}: onOpen()`); // eslint-disable-line no-console

    this.newValue = this.value;
    this.newTextValue = this.value
      ? moment(this.value, 'YYYY-MM-DD').format('DD/MM/YYYY')
      : null;
  }

  // È stata selezionata una data
  async onSave() {
    console.log(`${this.constructor.name}: onSelect() onSave =`, this.newValue); // eslint-disable-line no-console

    // Trasforma in un valore di tipo Date prima di restituirlo
    const selectedDate = this.newValue
      ? moment(this.newValue, 'YYYY-MM-DD').toDate()
      : null;

    this.$emit('select', selectedDate);
  }
}
